import { createContext, useContext } from 'react';
import { DependentType, DocumentType } from '../schema';
import { FormMode } from '@/types/form';

interface NhanVienContextType {
  // State
  showForm: boolean;
  formMode: FormMode;
  selectedRow: DocumentType | null;
  documentRows: DocumentType[];
  dependentRows: DependentType[];

  // Actions
  setShowForm: (show: boolean) => void;
  setFormMode: (mode: FormMode) => void;
  setSelectedRow: (row: DocumentType | null) => void;

  // Handlers
  handleAdd: () => void;
  handleEdit: () => void;
  handleDelete: () => void;
  handleCopy: () => void;
  handlePrint: () => void;
  handleSearch: () => void;
  handleRowClick: (row: DocumentType) => void;
}

// Create context with default values
export const NhanVienContext = createContext<NhanVienContextType>({
  // Default state values
  showForm: false,
  formMode: 'view',
  selectedRow: null,
  documentRows: [],
  dependentRows: [],

  // Default action implementations (no-op)
  setShowForm: () => {},
  setFormMode: () => {},
  setSelectedRow: () => {},

  // Default handler implementations (no-op)
  handleAdd: () => {},
  handleEdit: () => {},
  handleDelete: () => {},
  handleCopy: () => {},
  handlePrint: () => {},
  handleSearch: () => {},
  handleRowClick: () => {}
});

// Custom hook to use the NhanVien context
export const useNhanVienContext = () => useContext(NhanVienContext);
